export default {
  API_URL: "https://api.incentive.app/manager",
};
